













































import { Component, PropSync, Vue } from "vue-property-decorator";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import { producto } from "@/shared/dtos/producto";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import productoModule from "@/store/modules/producto-module";
import { MessageService } from "@/shared/services/message-service";
import { ProcessoNums } from "./ProcessoNums";
@Component({
  components: {
    ConfirmDialog,
  },
})
export default class ProcesoReparacion extends Vue {
  @PropSync("id", { default: -1 }) id_prodcuto!: number;
  @PropSync("show", { default: false }) Xshow!: boolean;
  public selectedRow: producto = new producto();

  async created() {
    if (!(productoModule.productos.length > 0)) {
      await productoModule.getproductos();
    }
    this.selectedRow = productoModule.productos.find(
      (x) => x.id == this.id_prodcuto
    ) || new producto();
  }

  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }
  aceptar() {
    this.selectedRow.estado = ProcessoNums.Reparacion;
    this.selectedRow.precio_vendido = 0;
    this.selectedRow.vendido = false;
    productoModule.modificarproducto(this.selectedRow).then(() => {
      this.cancelar();
      MessageService.toast(
        "Enviado a reparación, ahora no se verá en la página web"
      );
      productoModule.getproductos();
    });
  }
  cancelar() {
    this.Xshow = false;
  }
}
